// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError, AxiosResponse } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap, debounceTime } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { getNotifications } from '../../../apis/member';
import { getNotificationsActions, GetNotificationsSuccessPayload } from '../../actionCreators/notifications/getNotificationsActions';
import { RootAction } from '../../rootActionCreator';

const outputActions = {
  success: getNotificationsActions.success,
  failure: getNotificationsActions.failure
};

type RequestActionTypes = ActionType<
  typeof getNotificationsActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

export const getNotificationsEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      getType(getNotificationsActions.request)
    ),
    debounceTime(2000),
    switchMap((action: RequestActionTypes) => {
      const { page, limit } = action.payload;

      return getNotifications(page, limit)
        .then((resp: AxiosResponse<GetNotificationsSuccessPayload>) => {
          return getNotificationsActions.success({
            ...resp.data
          });
        })
        .catch((error: AxiosError) => {
          // handle error case here
          return getNotificationsActions.failure({ error });
        });
    })
  );
};
